export const setLecturesState = ({ isAuth, lectureId }) =>
  isAuth ? ["lecture", "registered", lectureId] : ["lecture", "unregistered", lectureId];
export const setCourseState = ({ isAuth, id }) =>
  isAuth
    ? ["course", "content", "registered", id]
    : ["course", "content", "unregistered", id];
